import { useState } from 'react';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';

const Photos = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const photos = [
    { id: 1,  url: '/photo-site/exterieur/IMG_0351.jpeg',  title: 'La Marmotte Joyeuse - Vue extérieure', alt: 'Vue extérieure de La Marmotte Joyeuse à La Grave' },
    { id: 2,  url: '/photo-site/exterieur/IMG_1094.jpeg',  title: 'Village de La Grave', alt: 'Village de La Grave face à la Meije' },
    { id: 3,  url: '/photo-site/exterieur/IMG_1095.jpeg',  title: 'La Grave - Paysage alpin', alt: 'Paysage alpin du village de La Grave' },
    { id: 4,  url: '/photo-site/exterieur/IMG_1096.jpeg',  title: 'Environnement montagnard', alt: 'Environnement montagnard de La Grave' },
    { id: 5,  url: '/photo-site/exterieur/IMG_1534.jpeg',  title: 'La Meije', alt: 'Vue sur le massif de la Meije depuis La Grave' },
    { id: 6,  url: '/photo-site/exterieur/IMG_2432.jpeg',  title: 'La Grave en été', alt: 'Village de La Grave en été' },
    { id: 7,  url: '/photo-site/exterieur/IMG_4549.jpeg',  title: 'Façade La Marmotte Joyeuse', alt: 'Façade de la maison La Marmotte Joyeuse' },
    { id: 8,  url: '/photo-site/exterieur/IMG_4554.jpeg',  title: 'Alentours de La Grave', alt: 'Alentours du village de La Grave' },
    { id: 9,  url: '/photo-site/exterieur/IMG_4555.jpeg',  title: 'Vue village', alt: 'Vue sur le village de La Grave' },
    { id: 10, url: '/photo-site/exterieur/IMG_4556.jpeg',  title: 'Paysage hivernal', alt: 'Paysage hivernal à La Grave' },
    { id: 11, url: '/photo-site/exterieur/IMG_4580.jpeg',  title: 'La Grave hiver', alt: 'Village de La Grave en hiver' },
    { id: 12, url: '/photo-site/exterieur/IMG_4584.jpeg',  title: 'Massif alpin', alt: 'Massif alpin vu depuis La Grave' },
    { id: 13, url: '/photo-site/exterieur/IMG_4589.jpeg',  title: 'Téléphérique de La Grave', alt: 'Téléphérique de La Grave - La Meije' },
    { id: 14, url: '/photo-site/exterieur/IMG_6303.jpeg',  title: 'Rue du village', alt: 'Rue authentique du village de La Grave' },
    { id: 15, url: '/photo-site/exterieur/IMG_6305.jpeg',  title: 'Architecture alpine', alt: 'Architecture alpine du village de La Grave' },
    { id: 16, url: '/photo-site/exterieur/IMG_6309.jpeg',  title: 'Maison de village', alt: 'Maison de village authentique à La Grave' },
    { id: 17, url: '/photo-site/exterieur/IMG_6324.jpeg',  title: 'Vue sur la vallée', alt: 'Vue sur la vallée depuis La Grave' },
    { id: 18, url: '/photo-site/exterieur/IMG_6623.jpeg',  title: 'Panorama montagne', alt: 'Panorama montagne depuis La Grave' },
    { id: 19, url: '/photo-site/exterieur/IMG_6781.jpeg',  title: 'Paysage de La Grave', alt: 'Paysage authentique de La Grave' },
    { id: 20, url: '/photo-site/exterieur/IMG_6810.jpeg',  title: 'La Marmotte Joyeuse', alt: 'La Marmotte Joyeuse - hébergement à La Grave' },
    { id: 21, url: '/photo-site/exterieur/IMG_6811.jpeg',  title: 'Entrée du logement', alt: 'Entrée de La Marmotte Joyeuse' },
    { id: 22, url: '/photo-site/exterieur/IMG_6822.jpeg',  title: 'Détail extérieur', alt: 'Détail extérieur de La Marmotte Joyeuse' },
    { id: 23, url: '/photo-site/exterieur/IMG_6822b.jpeg', title: 'Extérieur maison', alt: 'Vue extérieure de la maison' },
    { id: 24, url: '/photo-site/exterieur/IMG_6825.jpeg',  title: 'Village classé', alt: 'Village classé Plus Beaux Villages de France - La Grave' },
    { id: 25, url: '/photo-site/exterieur/IMG_7226.jpeg',  title: 'La Grave en saison', alt: 'La Grave en saison' },
    { id: 26, url: '/photo-site/exterieur/IMG_7231.jpeg',  title: 'Vue panoramique', alt: 'Vue panoramique sur La Grave et la Meije' },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    "name": "Album Photos La Marmotte Joyeuse",
    "description": "Découvrez en images nos appartements et les magnifiques paysages des Alpes françaises depuis La Marmotte Joyeuse.",
    "image": photos.map(photo => ({
      "@type": "ImageObject",
      "url": `https://marmottejoyeuse.fr${photo.url}`,
      "name": photo.title,
      "description": photo.alt
    }))
  };

  return (
    <>
      <SEO
        title={t('seo.photos.title')}
        description={t('seo.photos.description')}
        keywords="photos la grave, galerie alpes, images hébergement, photos appartement, paysage montagne, marmotte joyeuse photos"
        url="/photos"
        structuredData={structuredData}
      />
      <div className="container mx-auto px-4 pt-28 pb-16 min-h-screen">
        <h1 className="text-4xl font-bold mb-8 text-center">{t('photos.title')}</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {photos.map((photo) => (
          <div 
            key={photo.id}
            className="group relative aspect-square overflow-hidden rounded-xl cursor-pointer"
            onClick={() => setSelectedImage(photo)}
          >
            <img 
              src={photo.url}
              alt={photo.alt}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              loading="lazy"
              width="400"
              height="400"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-lg font-semibold text-center p-4">
                {photo.title}
              </p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full">
            <img 
              src={selectedImage.url}
              alt={selectedImage.alt}
              className="w-full h-auto rounded-xl"
              loading="lazy"
            />
            <p className="absolute bottom-4 left-4 text-white text-xl font-semibold">
              {selectedImage.title}
            </p>
            <button 
              className="absolute top-4 right-4 text-white text-xl font-bold bg-black/50 w-10 h-10 rounded-full hover:bg-black/75 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(null);
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default Photos;
